import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { useAuth, useProfile } from "@brg/auth";
import { useGetCatalogs } from "shared/hooks/api/useGetCatalogs";
import { useMemo } from "react";
import { CreateExternalLinkTo } from "shared/constants/linkTo";
import { AppTester } from "supporting";
import { ComingSoonTab } from "../components/ComingSoonTab";

export const useKiiidsArtTabs = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { designerId, accountId } = useProfile() || {}
  const { emit } = useAuth()
  const isKiiidsArt = AppTester.isKiiidsArt()

  const collections : any = useGetCatalogs('kids', accountId || '', false, !isKiiidsArt)

  const firstCard = useMemo(() => {
    return collections?.catalogs?.[0].firstCard?.cardId || ''
  }, [collections?.catalogs])

  const userId = designerId || accountId

  return {
    [NAVBAR_TAB_NAMES.museum]: {
      active: false,
      content: t("nav.kiiids_art.museum").toLowerCase(),
      level: 2,
      linkTo: CreateExternalLinkTo.kiiidsArt('/catalog/kiids_art?card=cf7b7efd5e774d16ad20185e495fc23b'),
      target: '_self',
      // desktopOnly: true
    },
    [NAVBAR_TAB_NAMES.kiiids_my_collection]: {
      active: false,
      content: t("nav.kiiids_art.collection").toLowerCase(),
      level: 2,
      linkTo: !!userId && CreateExternalLinkTo.kiiidsArt(`/collection/${userId}?card=${firstCard}&shouldLogin=true&saveLoginUrl=true`),
      target: '_self',
      action: () => {
        if (!userId) {
          emit('login')
        }
      },
      // desktopOnly: true
    },
    [NAVBAR_TAB_NAMES.kiiids_tags]: {
      active: false,
      content: t("nav.kiiids_art.tags"),
      level: 2,
      linkTo: CreateExternalLinkTo.kiiidsArt('/tags'),
      target: '_self',
      // desktopOnly: true
    },
    [NAVBAR_TAB_NAMES.kiiids_publishing]: {
      active: location?.pathname === '/',
      content: t("nav.kiiids_art.publishing"),
      level: 2,
      linkTo: '/',
      target: '_self',
    },
    [NAVBAR_TAB_NAMES.kiiids_school]: {
      active: false,
      content: <ComingSoonTab>{t("nav.kiiids_art.school")}</ComingSoonTab>,
      level: 2,
      disabled: true

    },
    [NAVBAR_TAB_NAMES.kiiids_competitions]: {
      active: location?.pathname === '/awards',
      content: t("nav.kiiids_art.awards"),
      level: 2,
      linkTo: '/awards',
    },
    [NAVBAR_TAB_NAMES.kiiids_media_for_parents]: {
      active: false,
      content: t("nav.kiiids_art.media_for_parents"),
      level: 2,
      linkTo: 'https://kiiids.ru/',
      target: '_self',
    },
    [NAVBAR_TAB_NAMES.kiiids_about]: {
      active: false,
      content: t("nav.kiiids_art.about"),
      level: 2,
      linkTo: CreateExternalLinkTo.kiiidsArt('/about'),
      target: '_self',
    },

  }
}import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { useAuth, useProfile } from "@brg/auth";
import { useGetCatalogs } from "shared/hooks/api/useGetCatalogs";
import { useMemo } from "react";
import { CreateExternalLinkTo } from "shared/constants/linkTo";
import { AppTester } from "supporting";
import { ComingSoonTab } from "../components/ComingSoonTab";

export const useKiiidsArtTabs = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const { designerId, accountId } = useProfile() || {}
  const { emit } = useAuth()
  const isKiiidsArt = AppTester.isKiiidsArt()

  const collections : any = useGetCatalogs('kids', accountId || '', false, !isKiiidsArt)

  const firstCard = useMemo(() => {
    return collections?.catalogs?.[0].firstCard?.cardId || ''
  }, [collections?.catalogs])

  const userId = designerId || accountId

  return {
    [NAVBAR_TAB_NAMES.museum]: {
      active: false,
      content: t("nav.kiiids_art.museum").toLowerCase(),
      level: 2,
      linkTo: CreateExternalLinkTo.kiiidsArt('/catalog/kiids_art?card=cf7b7efd5e774d16ad20185e495fc23b'),
      target: '_self',
      // desktopOnly: true
    },
    [NAVBAR_TAB_NAMES.kiiids_my_collection]: {
      active: false,
      content: t("nav.kiiids_art.collection").toLowerCase(),
      level: 2,
      linkTo: !!userId && CreateExternalLinkTo.kiiidsArt(`/collection/${userId}?card=${firstCard}&shouldLogin=true&saveLoginUrl=true`),
      target: '_self',
      action: () => {
        if (!userId) {
          emit('login')
        }
      },
      // desktopOnly: true
    },
    [NAVBAR_TAB_NAMES.kiiids_tags]: {
      active: false,
      content: t("nav.kiiids_art.tags"),
      level: 2,
      linkTo: CreateExternalLinkTo.kiiidsArt('/tags'),
      target: '_self',
      // desktopOnly: true
    },
    [NAVBAR_TAB_NAMES.kiiids_publishing]: {
      active: location?.pathname === '/',
      content: t("nav.kiiids_art.publishing"),
      level: 2,
      linkTo: '/',
      target: '_self',
    },
    [NAVBAR_TAB_NAMES.kiiids_school]: {
      active: false,
      content: <ComingSoonTab>{t("nav.kiiids_art.school")}</ComingSoonTab>,
      level: 2,
      disabled: true

    },
    [NAVBAR_TAB_NAMES.kiiids_competitions]: {
      active: location?.pathname === '/awards',
      content: t("nav.kiiids_art.awards"),
      level: 2,
      linkTo: '/awards',
    },
    [NAVBAR_TAB_NAMES.kiiids_media_for_parents]: {
      active: false,
      content: t("nav.kiiids_art.media_for_parents"),
      level: 2,
      linkTo: 'https://kiiids.ru/',
      target: '_self',
    },
    [NAVBAR_TAB_NAMES.kiiids_about]: {
      active: false,
      content: t("nav.kiiids_art.about"),
      level: 2,
      linkTo: CreateExternalLinkTo.kiiidsArt('/about'),
      target: '_self',
    },

  }
}